import Dashboard from "../Pages/Dashboard/Dashboard";
import Users from "../Pages/Masters/Users";
import Categories from "../Pages/Masters/Categories";
import HeroSliders from "../Pages/Masters/HeroSliders";
import ManageProducts from "../Pages/Masters/Products/ManageProducts";
import ProductList from "../Pages/Masters/Products/ProductList";
import ManageProductCategories from "../Pages/Masters/Products/ManageProductCategories";
import ManageProductFeatures from "../Pages/Masters/Products/ManageProductFeatures";
import ManageProductGallery from "../Pages/Masters/Products/ManageProductGallery";
import InquiryEmails from "../Pages/Masters/InquiryEmails";

const routes = [
  ////////////////////// Dashboard Routing ///////////////////////////
  { path: "/", element: <Dashboard />, routeName: "/" },

  ////////////////////// Accounts Routing ///////////////////////////
  { path: "/Masters/ManageUser", element: <Users />, routeName: "/Masters/ManageUser" },
  { path: "/Masters/ManageCategory", element: <Categories />, routeName: "/Masters/ManageCategory" },
  { path: "/Masters/ManageHeroSlider", element: <HeroSliders />, routeName: "/Masters/ManageHeroSlider" },
  { path: "/Masters/InquiryEmails", element: <InquiryEmails />, routeName: "/Masters/InquiryEmails" },
  { path: "/Masters/ProductList", element: <ProductList />, routeName: "/Masters/ProductList" },
  { path: "/Masters/ManageProductCategories", element: <ManageProductCategories />, routeName: "/Masters/ManageProductCategories" },
  { path: "/Masters/ManageProducts/:product_id?", element: <ManageProducts />, routeName: "/Masters/ManageProducts" },
  { path: "/Masters/ManageProductFeatures/:product_id?", element: <ManageProductFeatures />, routeName: "/Masters/ManageProductFeatures" },
  { path: "/Masters/ManageProductGallery/:product_id?", element: <ManageProductGallery />, routeName: "/Masters/ManageProductGallery" },
];

export default routes;